import React, { ReactNode } from 'react';
import { Observable } from 'rxjs';
import { FullWidthBannerColorPalette } from './fullWidthBanner';

export interface BannerData<T = any> {
  color?: FullWidthBannerColorPalette;
  bannerTitle?: string;
  message: string | React.ComponentType<any> | ReactNode;
  messageContext?: T;
  canClose?: boolean;
  closeOnAction?: boolean;
  thumbnailSrc?: string;
  thumbnailName?: string;
  actionName?: string;
  actionIcon?: string;
  openCallback?: () => any;
  actionCallback?: () => any;
  closeClickCallback?: () => any;
  closeCallback?: (reason?: BannerCloseReason) => any;
  triggerClose$?: Observable<BannerCloseReason>;
}

export enum BannerCloseReason {
  ACTION,
  DISCARD
}
